import axios from "axios";
export default function AfficheCommandeClient(){

    const GetCommandeClient = (id?: string) => {
        const urlShowCommandeClient = id 
            ? `${process.env.REACT_APP_PHP_APP_URL}/client/${id}/commandes`
            : `${process.env.REACT_APP_PHP_APP_URL}/admin/client/commande`;
        return (axios.get(urlShowCommandeClient));
    }
    return {
        GetCommandeClient
    }
}
